import { riseIn } from "../../style/styled-components/keyframes/fade";
import HomeImage from "../../resources/images/background/main-bg.jpg";
import HomeTab from "../../components/contents/HomeTab";
import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import HomeShortcuts from "../../components/contents/HomeShortcuts";
import { languageStore } from "../../state/language";
import { Helmet } from "react-helmet";
import HomeOmbudsman from "../../components/contents/HomeOmbudsman";
import NoticeBar from "../../components/ui/intro/NoticeBar";
import HomeTrust from "../../components/contents/HomeTrust";

const Home = () => {
  const { language } = languageStore();

  return (
    <>
    <NoticeBar />
    <Div>
      <Helmet>
        <meta charSet="utf-8" />
        {/* description·keywords는 public/index.html 한 곳에서 관리 (여기 또 두면 홈에 두 벌이 생긴다) */}
        <link rel="canonical" href="https://www.aonecustoms.com/" />
        <meta name="author" content="관세법인 에이원" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>
          {`${
            language === "EN"
              ? "AONE Customs and Trade Service"
              : "관세법인 에이원"
          }`}{" "}
        </title>
        <link
          rel="icon"
          type="image/x-icon"
          href="./resources/images/logo/aone_logo_only.ico"
        />
      </Helmet>
      <Hero>
        <div className="bg" aria-hidden="true" />
        <div className="inner">
          <div className="copy">
            <span className="eyebrow">
              {language === "EN" ? "AONE Customs & Trade Service" : "관세법인 에이원"}
            </span>
            <h1>
              {language === "EN" ? (
                "CUSTOMS EXPERTISE, POWERED BY IT"
              ) : (
                <>
                  관세의 전문성에
                  <br />
                  <em>IT를 더하다</em>
                </>
              )}
            </h1>
            <p>
              {language === "EN"
                ? "Experts who build their own platform."
                : "관세 전문가가 만든 플랫폼으로 일합니다."}
            </p>
            <div className="cta">
              <Link to="/impexp" className="primary">
                업무분야 보기
              </Link>
              <Link to="/it/ascp" className="ghost">
                ASCP 플랫폼 <span aria-hidden="true">→</span>
              </Link>
            </div>
          </div>
        </div>
        <div className="shortcuts">
          <HomeShortcuts />
        </div>
      </Hero>
      <HomeTab />
      <HomeTrust />
      <HomeOmbudsman />
    </Div>
    </>
  );
};

export default Home;

const kenBurns = keyframes`
  from {
    transform: scale(1.08);
  }
  to {
    transform: scale(1);
  }
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

const Hero = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: min(86vh, 48rem);
  overflow: hidden;
  color: white;
  background-color: ${({ theme }) => theme.colors.ink};
  & > .bg {
    position: absolute;
    inset: 0;
    background-image: linear-gradient(
        100deg,
        rgba(11, 22, 61, 0.92) 0%,
        rgba(11, 22, 61, 0.7) 45%,
        rgba(11, 22, 61, 0.25) 100%
      ),
      url(${HomeImage});
    background-size: cover;
    background-position: center 42%;
    animation: ${kenBurns} 8s ease-out forwards;
  }
  & > .inner {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 90rem;
    margin: 0 auto;
    padding: 6rem clamp(1.25rem, 5vw, 4rem) 3rem;
    box-sizing: border-box;
  }
  & .copy {
    max-width: 44rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    & > * {
      opacity: 0;
      animation: ${riseIn} 0.8s ease-out forwards;
    }
    & > .eyebrow {
      display: inline-flex;
      align-items: center;
      gap: 0.6rem;
      font-size: 0.95rem;
      font-weight: 600;
      letter-spacing: 0.04em;
      color: ${({ theme }) => theme.colors.foreground.highlightinverted};
      animation-delay: 0.1s;
      &:before {
        content: "";
        width: 2rem;
        height: 2px;
        background-color: currentColor;
      }
    }
    & > h1 {
      margin: 1.25rem 0 1rem;
      font-size: clamp(2.4rem, 5.6vw, 4.5rem);
      line-height: 1.15;
      font-weight: 800;
      letter-spacing: -0.035em;
      animation-delay: 0.25s;
      & > em {
        font-style: normal;
        background: linear-gradient(90deg, ${({ theme }) => theme.colors.foreground.highlightinverted}, #ffffff 70%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }
    }
    & > p {
      margin: 0;
      font-size: clamp(1.1rem, 2vw, 1.5rem);
      font-weight: 400;
      color: rgba(255, 255, 255, 0.82);
      animation-delay: 0.4s;
    }
    & > .cta {
      display: flex;
      flex-wrap: wrap;
      gap: 0.75rem;
      margin-top: 2.5rem;
      animation-delay: 0.55s;
      & > a {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.95rem 1.6rem;
        border-radius: 999px;
        font-weight: 700;
        transition: background-color 0.2s, color 0.2s, border-color 0.2s;
      }
      & > a.primary {
        background-color: white;
        color: ${({ theme }) => theme.colors.dark};
        &:hover {
          background-color: ${({ theme }) => theme.colors.accentSoft};
        }
      }
      & > a.ghost {
        border: 1px solid rgba(255, 255, 255, 0.5);
        color: white;
        &:hover {
          border-color: white;
          background-color: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
  & > .shortcuts {
    position: relative;
    width: 100%;
    max-width: 90rem;
    margin: 0 auto;
    padding: 0 clamp(1.25rem, 5vw, 4rem) 2.5rem;
    box-sizing: border-box;
    opacity: 0;
    animation: ${riseIn} 0.8s 0.7s ease-out forwards;
  }
`;
